/**
 * Localization messages for useActivationBanner hook
 * Following invertedMessages pattern from @saviynt/common
 */
const invertedMessages = {
  'Your {roleName} Role has been activated!':
    'roleRecs.banner.roleActivationSuccess',
  "Your role {roleName} couldn't be activated.":
    'roleRecs.banner.roleActivationError',
} as const;

export default invertedMessages;
